"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/* istanbul ignore file */
var IStrategy = /*#__PURE__*/function () {
  function IStrategy() {
    (0, _classCallCheck2["default"])(this, IStrategy);
  }
  return (0, _createClass2["default"])(IStrategy, [{
    key: "run",
    value: function run() {}
  }], [{
    key: "build",
    value: function build() {}
  }]);
}();
exports = module.exports = IStrategy;